import { render, staticRenderFns } from "./LoginPage.vue?vue&type=template&id=72d2a26c&scoped=true&"
import script from "./LoginPage.vue?vue&type=script&lang=js&"
export * from "./LoginPage.vue?vue&type=script&lang=js&"
import style0 from "./LoginPage.vue?vue&type=style&index=0&id=72d2a26c&lang=scss&scoped=true&"
import style1 from "./LoginPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d2a26c",
  null
  
)

export default component.exports